import { ReviewFormType } from "types/form";
import http from "services/http";

const V3_ENDPOINT = "/api/method/freshdi.api.web.v3";

export const apiCreateReview = (data: ReviewFormType) =>
  http.post(`${V3_ENDPOINT}.review.create_review`, data);

export const apiGetReviews = (data: {
  review_type: "Buyer" | "Supplier";
  reference_name?: string;
  offset?: number;
  limit?: number;
}) => http.get(`${V3_ENDPOINT}.review.get_reviews`, { params: data });
